//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'TechMeetup #7 System analysis | МТС Финтех',
  logo: {
    image: require('@/assets/logo/TechMeetup Logo-1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'TechMeetup #7 System analysis | МТС Финтех',
  description: [
    'В начале осени, 11 сентября 2024 года, мы приглашаем тебя на следующий TechMeetup #7, посвящённый системному анализу и его различным аспектам.',
    'На мероприятии тебя ждут интересные спикеры, нетворкинг; теплая программа и приятная компания — что может быть круче?',
    'За актуальными анонсами и новостями мероприятия следи в <a href="https://t.me/tech_meetup" target="_blank">@tech_meetup</a> и <a href="https://t.me/tech_meetup_sa" target="_blank">@tech_meetup_sa</a>, если интересна только системная аналитика.',
    '➡️ Если ты желаешь выступить на наших будущих встречах, пиши <a href="https://t.me/ficusmom" target="_blank">@ficusmom</a> или <a href="https://t.me/SayPoj" target="_blank">@SayPoj</a>.',
    '💡 Даже если у есть только идея, но вам кажется, что она может быть интересной, или вы просто чувствуете вдохновение — не стесняйтесь писать. Мы поможем превратить задумку в полноценный доклад и поддержим на всех этапах, начиная с идеи и до выступления.',
    '🔗 Интересно узнать о работе в МТС Финтех, посмотреть вакансии, новости и лайфхаки? Добавляйся в tg-канал <a href="https://t.me/+Lfqn35_QoVZjYWUy" target="_blank">@mtsfintechjobs</a> — там пишут о проектах, технологиях и том, что за ними стоит!',
    '',
    '',
    '',
    '',
    '',
    ''
  ],
  date: '11.09.2024',
  time: '18:00 - 22:00'
  },
  activities: [
    {
      tabName: '15.06.3023', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'EJBXtetz',
          id: 3236,
          hallName: 'Первый зал' // название зала
        }
      ]
    }

  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/2024-08-16 02.55.28.jpg'), // путь до изображения для блока с картинкой
    items: [
      'Мероприятие пройдет в медиаруме офиса МТС Банка по адресу: г. Москва, проспект Андропова 18, корпус 1. Вход в медиарум расположен слева от главного входа в здание банка.',
      '<b>Как добраться на общественном транспорте:</b>',
      'Метро Технопарк (зеленая ветка, Юг), выходы 1, 2 или 3. Здание с вывеской МТС Банк. Мы находимся в 2-х минутах ходьбы от метро.',
      '<b>Как добраться на личном автомобиле:</b>',
      'Есть несколько платных парковок: <uh> <li>Городской открытый паркинг – 40 р/час</li> <li>Многоуровневый парковый комплекс ТРЦ «Мегаполис»: первые 4 часа – 50 р, далее – 50 р/час</li> ',
      '',
      ''
    ]
  },
  info: {
    title: 'О площадке', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      'Данный блок достаточно гибкий, в него можно поместить текст, картинки и ссылки по аналогии с первый блоком на данной странице. Часто сюда попадает та информация, о которой хотят сказать организаторы, но которую не считают настолько нужной, чтобы помещать ее перед плеером.'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© TechMeetup,'
    // phone: '+7 926 260 53 22'
  }
}
